//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';

//Material-ui
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';

//Add
import moment from 'moment';

import PartPageTitle from './PartPageTitle';

//Icon



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      newLoginId: '',
      newLoginIdError: null,
      newLoginIdSaveDialog: false,
    }
	}

  componentDidMount() {
    document.title = '有料サービスの自動更新 - パートナーズ';
  }

  _chargeAutomaticChange(chargeAutomatic) {
    this.props.settingChargeAutomaticEdit(chargeAutomatic);
  }


  render() {
    let endDate =  moment.unix(this.props.my.setting.chargeEnd);

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'自動更新の設定'}
          onback={ '/setting/' }
        />

        {
          (this.props.my.setting.creditcardName) ? (
            <div>
              <div style={{padding:'10px'}}>
                 有料サービス終了日にクレジット決済のお手続きが不要で 30日プラン(¥2980)の有料サービスの更新が行えます。
              </div>

              <Grid container  justify="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
                <Grid
                  item
                  onClick={ () => this._chargeAutomaticChange(0) }
                  className='link'
                  style={{fontSize:'1.2em', textDecoration:'underline'}}
                >
                  OFF
                </Grid>
                <Grid item>
                  <Switch
                    onChange={ (event) => this._chargeAutomaticChange((event.target.checked ? 1 : 0)) }
                    checked={ (this.props.my.setting.chargeAutomatic === 1) ? true : false }
                  />
                </Grid>
                <Grid
                  item
                  onClick={ () => this._chargeAutomaticChange(1) }
                  className='link'
                  style={{fontSize:'1.2em', textDecoration:'underline'}}
                >
                  ON
                </Grid>
              </Grid>
              <div style={{padding:'10px'}}>
                {
                  (this.props.my.setting.chargeAutomatic === 1) ? (
                    <div> { endDate.format('YYYY年MM月DD日') } 23時頃に自動更新が行われます。</div>
                  ) : (
                    <div>自動更新は行われません、有料サービスの終了後は無料サービスに戻ります。</div>
                  )
                }
              </div>
            </div>
          ): (
            <div align='center' style={{padding:'10px'}}>クレジット情報がない為、自動更新の設定は行えません</div>
          )
        }


      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
